export class DependenteFinalidadeADO {
    iD_PESSOA : number;
    iD_PESSOA_DEP : number;
    iD_FINALIDADE : number;
    dT_INI : Date;
    dT_FIM : Date;
    pC_RATEIO : number;
    iD_MOTIVO_VALIDADE : number;
}